import { useQuery } from "react-query";
import { getRoleUsers } from "~/components/Forms/UsersForm/rolesRequest/getRoleUsers";

export default function useGetRoleUsers(id: string) {
  return useQuery({
    queryKey: ["getRoleUsers", id],
    queryFn: () => getRoleUsers(id),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    enabled: !!id,
    onSuccess: (data) => {
      console.log("useGetRole success:", data);
    },
    onError: (error) => {
      console.error("useGetRole error:", error);
    },
  });
}
